export default __webpack_public_path__ + "static/media/Warlord's Sanctum.2f0df28d.jpg";